import BaseModelAPI from '../BaseModelAPI';

export default class RepackingList extends BaseModelAPI {

	static entity = 'repackinglist'
	static entityName = 'repacking';

	constructor() {
		this.pageIndex = 0;
		this.pageSize = 0;
		this.pageCount = 0;
		this.dataCount = 0;
	}
}
